import SentimentTable from './sentimentTable'
export default SentimentTable
